import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { markChunksLoaded } from "./router/lazyScreen";

// Self-hosted brand fonts (UX-004 §2.1): Inter for text, JetBrains Mono for
// figures. Only the weights the type scale uses are bundled (Inter 400/500/600/800,
// mono 300/400) so nothing waits on an external font request — offline/edge safe.
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/800.css";
import "@fontsource/jetbrains-mono/300.css";
import "@fontsource/jetbrains-mono/400.css";

import "@solarkey/tokens/tokens.css";
// @solarkey/components v0.1.0 — the canonical wireframe component layer. Imported
// before our legacy @solarkey/ui + app styles so that, during the A1 migration,
// our existing .sk-* rules still win on any overlap and screens are unchanged
// until each is moved onto the package classes.
import "@solarkey/components/sk-components.css";
import "@solarkey/ui/styles.css";
import "./styles.css";

import { App } from "./App";

async function bootstrap() {
  // No live backend yet: serve the frozen contract from MSW before first paint.
  // Dynamic + DEV-guarded so MSW/faker tree-shake out of the production bundle entirely.
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS !== "false") {
    const { startMocks } = await import("./mocks/browser");
    await startMocks();
  }

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root not found");

  // This build booted, so any reload we did to escape a stale chunk is finished.
  // Clearing the guard means the NEXT deploy can heal an open tab the same way.
  markChunksLoaded();

  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
